import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  keywords,
  primaryKeyword,
  canonical,
  schema,
}) => {
  if (!title) {
    return null;
  }

  const schemaPayload = schema
    ? JSON.stringify(Array.isArray(schema) ? schema : [schema])
    : null;

  return (
    <Helmet>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      {primaryKeyword ? (
        <meta name="primary-keyword" content={primaryKeyword} />
      ) : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      {schemaPayload ? (
        <script type="application/ld+json">{schemaPayload}</script>
      ) : null}
    </Helmet>
  );
};

export default SEO;
